import { Button } from '@clarke-energia/foton';
import config from '@config';
import React from 'react';

const NoPermissions: React.FC = () => {
  return (
    <div className="flex overflow-y-auto flex-col justify-center items-center h-screen align-middle md:flex-row md:px-36">
      <div className="p-3 m-3 text-9xl font-extrabold text-right text-primary-60-green sm:text-180">403</div>
      <div className="flex flex-col justify-start items-start pl-10 mx-20 text-left align-middle border-l-2 border-clarke-green">
        <div className="font-semibold text-heading-xlarge">Acesso não autorizado</div>
        <div className="mt-2 w-full text-base font-light text-neutral-60">
          Sua conta está autenticada, mas você ainda não possui as permissões necessárias para acessar o sistema.
          <br />
          Por favor, entre em contato com um administrador para solicitar o acesso.
        </div>
        <div className="flex justify-start items-start mt-10 w-full px-4">
          <Button
            kind="primary"
            size="medium"
            label="Desconectar Conta"
            onClick={() => {
              window.location.href = `${config.SERVER_BASE_URL}/api/auth/logout`;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NoPermissions;
